// extracted by mini-css-extract-plugin
export default {"selectableTab":"SellOrTradeInEducation_selectableTab__3LBFX","modalContent":"SellOrTradeInEducation_modalContent__1QQHi"};